/** Нормализованный адрес, если он абсолютный http или https; иначе null */
export function safeHttpUrl(value: string | null | undefined): string | null {
  if (!value) {
    return null
  }

  try {
    const url = new URL(value.trim())

    return url.protocol === 'http:' || url.protocol === 'https:' ? url.href : null
  } catch {
    return null
  }
}
